const cepNo = (value, message) => {
  if (!value) {
    return null;
  }

  if (value.length !== 17) {
    return message ?? "Cep telefon numaranızı kontrol edin.";
  }

  return null;
};

export default cepNo;
